import styled from "styled-components";

export const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 1200px;

  .player__wrapper {
    position: relative;
    height: 600px;
  }

  .player {
    object-fit: cover;
    padding: 0;
    margin: 0;
    z-index: 5; /* set higher z-index value */
  }

  .secondaryVideosContainer {
    position: relative;
    width: 1065px;
    column-gap: 20px;
    row-gap: 0px;
    /* Aligns the children items in a row direction */
    display: flex;
    z-index: 5; /* set higher z-index value */
  }
`;
